// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mS6Y","colMin":"styles_colMin__1lQtr"};